import React, { useEffect, useState } from "react";
import { DatePicker, Flex, Modal, Select } from "antd";
import { Button, Form, Input } from "antd";
import { getMonth, getYear, isBefore, startOfToday } from "date-fns";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { List, Typography } from "antd";
import { format } from "date-fns";
import TextArea from "antd/es/input/TextArea";
import { BASE_API_URL } from "../../../utils/consts";
import dayjs from "dayjs";
import { ColorPicker } from "antd";

const { Option } = Select;

const { Text } = Typography;
type Props = {
  isOpen: boolean;
  onCloseModal: () => void;
  mode?: "create" | "edit";
  locations: any;
  clientId: any;
  onUpdate: () => void;
  workSectorData: any;
};

const WorkSectorModal: React.FC<Props> = ({
  isOpen,
  onCloseModal,
  locations,
  mode = "create",
  clientId,
  onUpdate,
  workSectorData,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [activeLocation, setActiveLocation] = useState<any>(undefined);
  const [color, setColor] = useState<string>("#ffffff");

  const handleOk = () => {
    onCloseModal();
    form.resetFields();
  };

  //   useEffect(() => {
  //     if (isOpen) {
  //       form.setFieldsValue({
  //         date: dayjs(), // današnji datum
  //       });
  //     }
  //   }, [isOpen, form]);

  useEffect(() => {
    if (isOpen) {
      if (mode === "edit" && workSectorData) {
        setColor(workSectorData.color || "#fff000");
        form.setFieldsValue({
          workSector: workSectorData.name || "",
          location: workSectorData.location?._id || undefined,
          color: workSectorData.color || "#ffffff",
          //   location: workSectorData.locationId || undefined,
          //   notes: workSectorData.notes || "",
        });
      } else {
        form.resetFields();
        form.setFieldsValue({
          date: dayjs(), // današnji datum
        });
      }
    }
  }, [isOpen, mode, workSectorData, form]);

  const handleCancel = () => {
    onCloseModal();
    form.resetFields();
  };
  const onFinish = async (values: any) => {
    if (mode === "create") {
      axios
        .post(`${BASE_API_URL}/admin/${clientId}/createWorkSector`, {
          name: values.workSector,
          clientId: clientId,
          notes: values.notes,
          location: values.location,
          color: color,
        })
        .then(() => {
          onUpdate();
        });
    } else {
      if (!workSectorData) return;
      axios
        .put(
          `${BASE_API_URL}/admin/${clientId}/updateWorkSector/${workSectorData._id}`,
          {
            name: values.workSector,
            clientId: clientId,
            notes: values.notes,
            location: values.location,
            color: color,
          }
        )
        .then(() => onUpdate())
        .catch();
    }
    onCloseModal();
  };

  useEffect(() => {}, []);

  const disabledPast = (current: any) => {
    return current && isBefore(current.toDate(), startOfToday());
  };

  return (
    <Modal
      title={<div className="">{t("Add Work Sector")}</div>}
      open={isOpen}
      onOk={handleOk}
      className="standardHeader"
      onCancel={handleCancel}
      footer={[]}
    >
      <Form
        name="fixedPaymentForm"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label={t("Work Sector")}
          name="workSector"
          rules={[{ required: true, message: t("Sector name required") }]}
        >
          <Input />
        </Form.Item>
        {/* <Form.Item
          name="location"
          label={t("Location")}
          rules={[{ required: true, message: "Please select location!" }]}
        >
          <Select
            placeholder={t("Select location  ")}
            onChange={(value, data) => setActiveLocation(data)}
            //   allowClear
            value={""}
          >
            {locations?.map((item: any, index: number) => {
              return (
                <Option value={item._id} key={index}>
                  {item.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item> */}
        <Form.Item
          name="location"
          label={t("Location")}
          rules={[{ required: true, message: t("Please select location!") }]}
        >
          <Select placeholder={t("Select location")}>
            {locations?.map((item: any) => (
              <Option value={item._id} key={item._id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label={t("Color")} name="color">
          <ColorPicker
            value={color}
            onChange={(value) => setColor(value.toHexString())}
          />
        </Form.Item>
        <Form.Item
          label={t("Notes")}
          name="notes"
          rules={[{ required: false, message: t("Please enter notes") }]}
        >
          <TextArea rows={2} />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Flex gap="small" wrap="wrap">
            <Button type="primary" htmlType="submit">
              {t("Save")}
            </Button>
            {/* {mode !== "create" && (
              <Button danger onClick={handleCancel}>
                {t("Delete")}
              </Button>
            )} */}
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default WorkSectorModal;
